export default "__VITE_ASSET__DIDlqEx9__"